import { render, staticRenderFns } from "./patientsPortalDashboard.vue?vue&type=template&id=6551df63&"
import script from "./patientsPortalDashboard.vue?vue&type=script&lang=js&"
export * from "./patientsPortalDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports